<ng-container [formGroup]="form"
              [ngSwitch]="dynamicFormEntry.valueType">

    <ng-container *ngSwitchCase="ValueTypes.String">
        <mat-form-field>
            <input [formControlName]="dynamicFormEntry.key"
                   [placeholder]="dynamicFormEntry.displayName"
                   [required]="dynamicFormEntry.isMandatory"
                   type="text"
                   matInput
                   [attr.data-cy]="dynamicFormEntry.key+'-String-input'" />
        </mat-form-field>
    </ng-container>

    <ng-container *ngSwitchCase="ValueTypes.Number">
        <mat-form-field>
            <input [formControlName]="dynamicFormEntry.key"
                   [placeholder]="dynamicFormEntry.displayName"
                   [required]="dynamicFormEntry.isMandatory"
                   type="number"
                   matInput
                   [attr.data-cy]="dynamicFormEntry.key+'-Number-input'" />
        </mat-form-field>
    </ng-container>

    <ng-container *ngSwitchCase="ValueTypes.Boolean">
        <mat-form-field>
            <ui-toggle-switch [onString]="'parameter_collection_true' | translate"
                              [offString]="'parameter_collection_false' | translate"
                              [required]="dynamicFormEntry.isMandatory"
                              [placeholder]="dynamicFormEntry.displayName"
                              [formControlName]="dynamicFormEntry.key"
                              [attr.data-cy]="dynamicFormEntry.key+'-Boolean-input'">
            </ui-toggle-switch>
        </mat-form-field>
    </ng-container>

    <ng-container *ngSwitchCase="ValueTypes.Choice">
        <mat-form-field>
            <ui-simple-multichoice-entry [required]="dynamicFormEntry.isMandatory"
                                         [placeholder]="dynamicFormEntry.displayName"
                                         [possibleValues]="dynamicFormEntry.possibleValues"
                                         [formControlName]="dynamicFormEntry.key"
                                         [attr.data-cy]="dynamicFormEntry.key+'-Choice-input'">
            </ui-simple-multichoice-entry>
        </mat-form-field>
    </ng-container>

    <ng-container *ngSwitchCase="ValueTypes.Section">
        <section>
            <h5>
                <span translate>dynamic_form_section</span>: {{dynamicFormEntry.displayName}}
            </h5>
            <ui-dynamic-configuration-form [dynamicFormEntries]="dynamicFormEntry.configurations"
                                           [form]="form.get(dynamicFormEntry.key)!">
            </ui-dynamic-configuration-form>
        </section>
    </ng-container>

</ng-container>
